import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy } from "react-table";

import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import PaginationAndSearching from "../../components/Pagination Component/paginationAndSearching";
import SkeletonTableRow from "../../components/SkeltonTable/skeletonTable";
import { useDispatch, useSelector } from "react-redux";
import PropertyListPage from "./propertyListPage";
import { getUserByPropIdApi } from "../../../service/property/getUserByPropId";
import { formatDate } from "../../../function/commonFunction";
import { useNavigate } from "react-router-dom";
//import './table.css';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Button, Divider, Grid } from "@mui/material";
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ExpiryDateFilter from "./ExpiryDateFilter";
import { findSubMenuByName } from "./MenuUtlis";
export const PendingPropertyListTable = ({
  column,
  rowsArr,
  handleVerify,
  handleSearchPagination,
  searchValuePagination,
  pageSizePagination,
  handleChangeRowsPerPagePagination,
  totalCountPagination,
  handleOnChangePagination,
  showLoading,
  handleDeleteById,
  handleTabExpanded,
  userArr,
  handleActionMultipleApprove,
  handleSeeVendor,
  totalCount,
  assignUsers,
  onLoadData,
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  setPageSizePending,
  setFilterType
}) => {
  const {permissionArr} = useSelector(state =>state.auth)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const columns = useMemo(() => column, []);
  const data = useMemo(() => rowsArr, [rowsArr]);
  const userData = useMemo(() => userArr, [userArr]);
  const [checkedRows, setCheckedRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const tableInstance = useTable({ columns, data }, useSortBy);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const {permissions} = useSelector(state =>state.permissionsData)

// Helper function to check if a specific action exists in a submenu
const hasAction = (submenu, actionName) => submenu?.Actions.includes(actionName);

// Find the "Properties" menu
const propertiesMenu = findSubMenuByName(permissions, 'Properties');
const listPropertyMenu = propertiesMenu ? findSubMenuByName(propertiesMenu?.SubMenus, 'List Property') : null;
// Check actions in the "Approved" submenu
const canApprove = listPropertyMenu ? hasAction(listPropertyMenu, 'Approve') : false;
const canSearch = listPropertyMenu ? hasAction(listPropertyMenu, 'Search') : false;
const canMoreFilter = listPropertyMenu ? hasAction(listPropertyMenu, 'MoreFilter') : false;
const canAudittrial = listPropertyMenu ? hasAction(listPropertyMenu, 'Audittrial') : false;
const canActive = listPropertyMenu ? hasAction(listPropertyMenu, 'Active') : false;
const canAddVendor = listPropertyMenu ? hasAction(listPropertyMenu, 'AddVendor') : false;
const canAssignUsers = listPropertyMenu ? hasAction(listPropertyMenu, 'AssignUsers') : false;
const canViewUsers = listPropertyMenu ? hasAction(listPropertyMenu, 'ViewUsers') : false;
const canViewVendors = listPropertyMenu ? hasAction(listPropertyMenu, 'ViewVendors') : false;
const MoreFilterSubMenu = listPropertyMenu ? findSubMenuByName(listPropertyMenu?.SubMenus, 'MoreFilters') : null;
const invoiceType = MoreFilterSubMenu ? hasAction(MoreFilterSubMenu, 'InvoiceType') : false;
const expiryDate = MoreFilterSubMenu ? hasAction(MoreFilterSubMenu, 'ExpiryDate') : false;

useEffect(()=>{},[userArr])
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    //footerGroups,
    rows,
    prepareRow,
  } = tableInstance;
  const [expandedRowIndex, setExpandedRowIndex] = useState(null);

 
  const toggleRowExpansion = (index) => {
    setExpandedRowIndex((prevIndex) => (prevIndex === index ? null : index));
  };
const [userArray,setUserArray] = useState([])
  function handleUserData(val)  {
setUserArray([])
    var data  ={
      PropertyId:val.Id
    }
    dispatch(getUserByPropIdApi(data,(res)=>{
      console.log(res.data?.result)
      setUserArray(res.data?.result)
    },()=>{}))
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePageSizeChange=(event)=>{
    setPageSizePending(event.target.value)
    }

    const [type, setTpe] = React.useState(permissionArr.some(role => /(telephone|admin)/i.test(role))?'Telephone':"Maintenance/Electricity");
    const handleChange = (event) => {
      setTpe(event.target.value);
    };
    useEffect(() => {
      setFilterType(type)
    }, [type])
  return (
    <>

      <div className="card">
        <div className="card-header">
     
          {/* <div className='pagination-search-container'>
                    <div className="service-input-group input-group">
                        <span className="input-group-text search-input-icon">

                            <i className="bi bi-search" style={{ fontSize: '16px' }}></i>
                        </span>
                        <input
                            type="text"
                            className="form-control search-input"
                            id="val-username1"
                            placeholder="Search..."
                            name="username"
                            value={searchValuePagination}
                            onChange={handleSearchPagination}
                        />
                        </div>
                    </div> */}
        </div>
        <div className="card-body">
        <h4> Total Pending Property : &nbsp; {totalCount}</h4> 
          <div className="d-flex justify-content-end">
            <div className="service-input-group input-group" style={{width:"220px"}}>
                        <span className="input-group-text search-input-icon">

                            <i className="bi bi-search" style={{ fontSize: '16px' }}></i>
                        </span>
                        <input
                            type="text"
                            className="form-control search-input"
                            id="val-username1"
                            placeholder="Search..."
                            name="username"
                            value={searchValuePagination}
                            onChange={handleSearchPagination}
                        />
                    </div>
                    {MoreFilterSubMenu && (<Button
        id="demo-positioned-button"
        aria-controls={open ? 'demo-positioned-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={{
          textTransform:'none'
        }}
      >
        More Filters<span class="material-icons">
arrow_drop_down
</span>
      </Button>)}
      <ExpiryDateFilter
 onLoadData={()=>onLoadData("InvoiceList",type)}
 open={open}
 fromDate={fromDate}
 toDate={toDate}
 setFromDate={setFromDate}
 anchorEl={anchorEl}
 handleClose={handleClose}
 setToDate={setToDate}
 type={type}
 handleChange={handleChange}
 isVendorList={true}
 showInvoiceType={invoiceType}
 showExpDate={expiryDate}
 setTpe={setTpe}
 />
            </div>
          <div className="table-responsive">
       
            <div className="dataTables_wrapper">
              <table {...getTableProps()} className="table dataTable display">
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                          style={{ color: "rgba(23, 90, 169, 0.78)" }}
                        >
                          {column.render("Header")}
                          <span className="ml-1">
                            {column.isSorted ? (
                              column.isSortedDesc ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
             
                <tbody {...getTableBodyProps()}>
                  {rows.map((row, rowIndex) => {
                    prepareRow(row);
                    return (

                      <>
                       <tr {...row.getRowProps()}>
                        {row.cells.map((cell, cellIndex) => {
                      const isLastColumn = cellIndex === row.cells.length - 1;
                    
                      const GSTIN = cellIndex == 6
                      const date = cellIndex== 7
                      const vendorName = cellIndex == 8
                      // {console.log(cell.render("Cell") )}

                          return (
                            <td
                              {...cell.getCellProps()}
                              style={{ color: "black" ,whiteSpace:'normal' }}
                            >
                         {isLastColumn ?
                          <div>
                            <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip id="tooltip">{"Edit"}</Tooltip>
                                        }
                                      >
                                        <i
                                          className="material-icons"
                                          style={{
                                            color: "orange",
                                            marginRight: "6px",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                       
                                              localStorage.setItem("editPropId",rows[rowIndex].original.Id)
                                         navigate("/registerProperty")
                                          }}
                                        >
                                          edit
                                        </i>
                                      </OverlayTrigger>
                          <i
                            className="material-icons"
                            style={{ cursor: "pointer",marginLeft:'5px' }}
                            onClick={() => {
                              if(expandedRowIndex != rowIndex){
                              handleTabExpanded( rows[rowIndex].original);
                              handleUserData(rows[rowIndex].original)
                              }
                              toggleRowExpansion(rowIndex)}}
                          >
                            {expandedRowIndex === rowIndex ? "remove" : "add"}
                          </i>
                                                       <span style={{marginLeft:'5px',cursor:'pointer'}} onClick={()=>assignUsers(rows[rowIndex].original)} title="assign users" className="material-icons">person_add</span>
                                                       
                         </div>: 
                         
                         (GSTIN && <div className="d-flex">

                          {cell.render("Cell")} 

                         </div>) ||( date &&  formatDate(rows[rowIndex].original.LeaseEndDate))|| (vendorName && <>
                         <span className="material-icons" style={{cursor:'pointer'}} onClick={()=>{handleSeeVendor(rows[rowIndex].original)}}>visibility</span>
                         </>) ||  cell.render("Cell") }
                           
                            </td>
                          );
                        })}

                      </tr>
                      {expandedRowIndex === rowIndex && (
                      <tr>
                      <td colSpan={row.cells.length} style={{ padding: 0,background:'rgb(211 211 211 / 40%)' }}  >
                        <table style={{width:'100%',background:'rgb(211 211 211 / 40%)'}}>
                          <thead>
                            <tr >
                              <th  style={{ color: "rgba(23, 90, 169, 0.78)" }}>Email</th>
                              <th  style={{ color: "rgba(23, 90, 169, 0.78)" }}>Phonenumber</th>
                              <th  style={{ color: "rgba(23, 90, 169, 0.78)" }}>Role</th>
                            </tr>
                          </thead>
                          <tbody style={{ color: "black" }}>
                         
{userArray.map((item,key)=>{
  
 return (<tr >
  <td style={{ whiteSpace: "normal" }}>
 {item.Email}
  </td>
  <td style={{ whiteSpace: "normal" }}>
  {item.Phone}
  </td>
  <td style={{ whiteSpace: "normal" }}>
  {item.Roles[0]}
  </td>
</tr>)
  
                  })}
                
                     
                          </tbody>
                        </table>
                        {userArray.length == 0 && (
                  
                  <div style={{ display: "flex", justifyContent: "center" }}>No result found</div>

                )}
                      </td>
                    </tr>
                  )}
                      </>
                     

                      
                      
                    );
                  })}
                </tbody>{" "}
             {showLoading &&   <SkeletonTableRow cols={4} row ={4}/>}
                {/* This is only for footer if u require */}
              </table>

              {rows.length === 0 && (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  No record found
                </div>
              )}


             
            </div>
          </div>
                            {/* Pagination & Page Size */}
                            <div className="pagination-container d-flex justify-content-between">
          <div style={{marginTop:"20px"}}>
            <label htmlFor="pageSizeSelect">Rows per page: </label>
            <select
              id="pageSizeSelect"
              value={pageSizePagination}
              onChange={handlePageSizeChange}
              style={{ marginLeft: "10px" }}
            >
                      <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={250}>250</option>
              <option value={500}>500</option>
            </select>
          </div>
          <PaginationAndSearching
                  handleSearch={handleSearchPagination}
                  searchValue={searchValuePagination}
                  defaultValue={pageSizePagination}
                  handleChangeRowsPerPage={handleChangeRowsPerPagePagination}
                  totalCount={totalCountPagination}
                  onChange={(e,p)=>{
                    handleOnChangePagination(e,p)
                    // setCheckedRows([])
                  }}
                />
                </div>
        </div>
      </div>
    </>
  );
};
export default PendingPropertyListTable;
